import { ImportEquipmentForm } from "@smartship-services/ui/forms";
import { useParams } from "react-router-dom";

const ImportEquipmentPage = () => {
  const { vesselId = "" } = useParams();
  return <ImportEquipmentForm vesselId={vesselId} />;
};

export default ImportEquipmentPage;
